module.exports = {
    // host_url: "http://118.89.40.223:7795", //http://118.89.40.223:7795   https://kefo.keanem.com/gzglshapi20210924
    // image_url: 'http://118.89.40.223/Photo/Beauty/', //http://118.89.40.223/Photo/Beauty/   https://kefo.keanem.com/Photo/Beauty/

    // host_url: 'https://kefo.keanem.com/gzglshapi20220301',
    // image_url: 'https://kefo.keanem.com/Photo/Beauty/'
    host_url: 'https://kefo.keanem.com/coc/api/release',
    image_url: 'https://kefo.keanem.com/Photo/Beauty/'
}